import React, { useEffect, useState } from 'react';
import { useNavigate, useLocation, useParams } from 'react-router-dom';
import SummaryApi from '../common';
import moment from 'moment';
import displayINRCurrency from '../helpers/displayCurrency';
import { FaEye } from 'react-icons/fa6';
import { AiOutlineLoading3Quarters } from 'react-icons/ai';
import { useSelector } from 'react-redux';
import { CiDeliveryTruck, CiTimer } from 'react-icons/ci';
import { MdModeEdit, MdOutlineDoneOutline } from 'react-icons/md';
import ChangeSalesMan from '../components/ChangeSalesMan';
import ChangeOrderStatus from '../components/ChangeOrderStatus';
import ChangeRequestStatus from '../components/ChangeRequestStatus';
import { RiRefund2Fill } from "react-icons/ri";
import ROLE from '../common/role';
import { HiXCircle } from "react-icons/hi";

const AdminPaymentAndOrders = () => {
  const { userId } = useParams();
  const [orderData, setOrderData] = useState([]);
  const [paymentData, setPaymentData] = useState([]);
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(true);
  const user = useSelector(state => state?.user?.user);
  const [selectedOrderId, setSelectedOrderId] = useState(null);
  const location = useLocation();
  const navigate = useNavigate();
  const { type } = location.state || {};
  const [startDate, setStartDate] = useState(moment().startOf('month').format('YYYY-MM-DD'));
  const [endDate, setEndDate] = useState(moment().endOf('month').format('YYYY-MM-DD'));
  const [userDetails, setUserDetails] = useState({});
  const [currentSalesman, setCurrentSalesman] = useState(''); 
  const [showChangeSalesMan, setShowChangeSalesMan] = useState(false);
  const [selectedStatus, setSelectedStatus] = useState('')
  const [openChangeStatus, setOpenChangeStatus] = useState(false);
  const [selectedRequest, setSelectedRequest] = useState(null);
  const [loadingPage, setLoadingPage] = useState(false);

  useEffect(() => {
    setLoadingPage(true);
    const loadingTimeout = setTimeout(() => {
      
      setLoadingPage(false);
      navigate("/");
    }, 10000); 
  
    if (user) {
      if (user?.role !== ROLE.ADMIN) {
        navigate('/');
        setLoadingPage(false);
      } 
      else {
        if(user?.type === "Admin"){
            navigate('/admin-panel/all-users');
            setLoadingPage(false);
        }
        else{
            setLoadingPage(false);
            clearTimeout(loadingTimeout);
        }
       
      }
    } 
  
    // Clear the timeout when the component unmounts or the effect is rerun
    return () => clearTimeout(loadingTimeout);
  }, [user, navigate]);

  useEffect(() => {
    fetchUserDetails();
    fetchUserOrders();
    fetchDeptRequestDetails();
  }, [startDate, endDate]); // Re-fetch data when dates change

  const fetchUserDetails = async () => {
    try {
      const response = await fetch(`${SummaryApi.getUserById.url}/${userId}`, {
        method: SummaryApi.getUserById.method,
        credentials: 'include',
      });
      const responseData = await response.json();
      if (responseData.success) {
        setUserDetails(responseData.data || {});
      } else {
        setError(responseData.message);
      }
    } catch (error) {
      setError('Error fetching user details');
    } finally {
      setLoading(false);
    }
  };

  const fetchUserOrders = async () => {
    try {
      const query = new URLSearchParams({
        type,
        startDate: moment(startDate).toISOString(),
        endDate: moment(endDate).toISOString(),
      }).toString();

      const response = await fetch(`${SummaryApi.adminViewUserOrders.url}/${userId}?${query}`, {
        method: SummaryApi.adminViewUserOrders.method,
        credentials: 'include',
      });

      const responseData = await response.json();
      if (responseData.success) {
        setOrderData(responseData.data || []);
      } else {
        setOrderData([]);
      }
    } catch (error) {
      setOrderData([]);
    }
  };

  const fetchDeptRequestDetails = async () => {
    try {
      const query = new URLSearchParams({
        type,
        startDate: moment(startDate).toISOString(),
        endDate: moment(endDate).toISOString(),
      }).toString();

      const response = await fetch(`${SummaryApi.adminGetDeptRequests.url}/${userId}?${query}`, {
        method: SummaryApi.adminGetDeptRequests.method,
        credentials: 'include',
      });

      const responseData = await response.json();
      if (responseData.success) {
        setPaymentData(responseData.data || []);
      } else {
        setError(responseData.message);
        setPaymentData([]);
      }
    } catch (error) {
      setError('Error fetching dept requests');
      setPaymentData([]);
    }
  };

  const mergedData = [
    ...orderData.map(item => ({ ...item, source: 'order' })),
    ...paymentData.map(item => ({ ...item, source: 'payment',type:'payment' })),
  ].sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt));

  if (loading) {
    return (
      <div className="flex justify-center items-center h-screen">
        <AiOutlineLoading3Quarters className="animate-spin text-6xl text-blue-500" />
      </div>
    );
  }

  const handleViewOrder = (orderId) => {
      navigate(`/admin-panel/adminViewAnOrder/${orderId}/${type}`);
  };


  const handleStatusClick = (orderId, currentStatus) => {
    setSelectedOrderId(orderId);
    setSelectedStatus(currentStatus);
    setShowChangeSalesMan(false); 
  };
  
  const handleChangeSalesManClick = (orderId, salesManName) => {
    setSelectedOrderId(orderId);
    setCurrentSalesman(salesManName || '');
    setShowChangeSalesMan(true);
  };

  const closeModal = () => {
    setSelectedOrderId(null);
    setSelectedStatus('');
    setShowChangeSalesMan(false); 
  };

  
  const refreshData = async () => {
    await fetchUserDetails(); 
    await fetchUserOrders();
    await fetchDeptRequestDetails();
    
};



if (loadingPage) {
  return (
      <div className="flex justify-center items-center h-screen">
          <AiOutlineLoading3Quarters className="animate-spin text-6xl text-blue-500" />
      </div>
  );
}

  return (
    <div className="min-h-[calc(100vh-120px)] flex flex-col">
         {/* User Details Section */}
      <div className="bg-white p-4 mb-4 border border-gray-300 rounded">
        {loading ? (
          <p>جاري التحميل</p>
        ) : error ? (
          <p>{error}</p>
        ) : (
          <div className="mb-4 p-4 border border-gray-300 bg-gray-100 rounded ">
                    <h2 className="text-xl font-bold mb-2">معلومات المستخدم</h2>
                    {userDetails.profilePic && (
                        <img src={userDetails.profilePic} alt="Profile" className="w-24 h-24 rounded-full" />
                    )}
                    <p className="mb-1"> {userDetails.name || 'N/A'}<strong>: الاسم</strong></p>
                    <p className="mb-1">{userDetails.email || 'N/A'} <strong>: البريد الالكترونى</strong> </p>

                    {type==='Medicine' &&
                    <p className="mb-1">
                        {userDetails?.medicineDebt?.$numberDecimal
                        ? displayINRCurrency (Number(userDetails.medicineDebt.$numberDecimal).toFixed(2))
                        : displayINRCurrency(0)}
                        <strong>: المديونية</strong>
                    </p>
                    }
                    {type==='Cosmetic' &&
                    <p className="mb-1">
                        {userDetails?.cosmeticDebt?.$numberDecimal
                        ? displayINRCurrency (Number(userDetails.cosmeticDebt.$numberDecimal).toFixed(2))
                        : displayINRCurrency(0)}
                        <strong>: المديونية</strong>
                    </p>
                    }

                    <p className="mb-1"> {userDetails.shippingAddress || 'N/A'} <strong>: العنوان</strong></p>
                    <p className="mb-1"> {userDetails.mobileNumber || 'N/A'} <strong>: رقم الهاتف المحمول</strong></p>

                </div>
        )}
      </div>
                    {/* Date Filter Section */}
                <div className="flex justify-end items-start mb-4">
                <div className="text-right">
                    <h2 className="text-xl font-bold mb-6">حدد المدة التي تريد ان تري بها سجل حسابات المستخدم</h2>

                    <div className="flex gap-6 justify-end">
                    {/* Start Date */}
                    <div>
                        <label htmlFor="startDate" className="block text-sm font-medium text-gray-700">
                        تاريخ البداية
                        </label>
                        <input
                        type="date"
                        id="startDate"
                        value={startDate}
                        onChange={(e) => setStartDate(e.target.value)}
                        className="mt-1 p-2 block w-full border border-gray-300 rounded-md"
                        />
                    </div>

      {/* End Date */}
                    <div>
                        <label htmlFor="endDate" className="block text-sm font-medium text-gray-700">
                        تاريخ النهاية
                        </label>
                        <input
                        type="date"
                        id="endDate"
                        value={endDate}
                        onChange={(e) => setEndDate(e.target.value)}
                        className="mt-1 p-2 block w-full border border-gray-300 rounded-md"
                        />
                    </div>
                    </div>
                </div>
                </div>
      {/* Main content */}
      <main className="w-full h-full p-4">
       
        {error ? (
          <p>{error}</p>
        ) : mergedData.length === 0 ? (
          <p>لا يوجد بيانات</p>
        ) : (
          <div className="overflow-x-auto">
            <table className="w-full border-collapse border border-gray-300">
              <thead>
                <tr className="bg-black text-white">
                  <th className="py-2 px-4 border border-gray-300 text-sm">كود الطلب/المديونية</th>
                  <th className="py-2 px-4 border border-gray-300 text-sm">اسم مندوب المبيعات المسئول</th>
                  <th className="py-2 px-4 border border-gray-300 text-sm">نوع العملية</th>
                  <th className="py-2 px-4 border border-gray-300 text-sm">حالة العملية</th>
                  <th className="py-2 px-4 border border-gray-300 text-sm">سعر العملية</th>
                  <th className="py-2 px-4 border border-gray-300 text-sm">اجمالى المديونية بالتاريخ</th>
                  <th className="py-2 px-4 border border-gray-300 text-sm">تاريخ العملية</th>
                  <th className="py-2 px-4 border border-gray-300 text-sm">تفاصيل الطلب</th>
                </tr>
              </thead>
              <tbody>
                {mergedData.map((item, index) => (
                  <tr
                    key={item._id || index}
                    className={`min-h-[80px] border-t border-gray-300 ${
                      item.source === 'order'
                        ? item.type === 'order'
                          ? 'bg-blue-100'
                          : item.type === 'refund'
                          ? 'bg-red-100'
                          : ''
                        : 'bg-yellow-100'
                    }`}
                  >
                    <td className="text-center py-2 px-4 border border-gray-300">
                      {item.source === 'order' ? `#${item.orderCode}` : `#${item.paymentCode}`}
                    </td>
                    <td className="text-center py-2 px-6 border border-gray-300">
                    {item.salesManName || 'لم يتم تعيين مندوب مبيعات لهذه العملية بعد'}
                    
                    {/* Show the edit icon only if the status is 'accepted' and the salesman name exists */}
                    {item.status === 'accepted' && item.type!=='refund'&& (
                        <button
                        className="inline-flex items-center justify-center bg-blue-100 p-2 rounded-full cursor-pointer hover:bg-blue-500 hover:text-white ml-2"
                        onClick={() => handleChangeSalesManClick(item._id, item.salesManName)}
                        >
                        <MdModeEdit className="text-xl" />
                        </button>
                    )}
                    </td>
                    <td className="text-center py-2 px-6 border border-gray-300">
                        {item.source === 'order' ? (
                          item.type === 'order' ? 'فاتورة' : item.type === 'refund' ? `مرتجع من طلب #${item.refundFromOrderNumber}` : ''
                        ) : (
                          'سداد مديونية'
                        )}
                      </td>


                   {item.source === 'order'&& item.type ==='order'&&
                   <td className="text-center py-2 px-6 border border-gray-300">
                    {   
                        item.status === 'pending'
                        ?  (
                            <>
                            <CiTimer className="inline-block mr-2 text-red-500 text-2xl" />
                            جاري تحضير الطلب
                            {/* Show edit icon if status is 'pending' */}
                            <button
                            className="inline-flex items-center justify-center bg-blue-100 p-2 rounded-full cursor-pointer hover:bg-blue-500 hover:text-white ml-2"
                            onClick={() => handleStatusClick(item._id)}
                            >
                            <MdModeEdit className="text-xl" />
                            </button>
                        </>
                            
                          ) :
                         item.status === 'accepted'&& item.salesManName === '' ?
                          (
                            <>
                            <CiDeliveryTruck className="inline-block mr-2 text-yellow-500 text-2xl" />
                            تم تحضير الطلب برجاء وضع مندوب مبيعات
                            {/* Show edit icon if status is 'accepted' and salesManName is empty */}
                            <button
                              className="inline-flex items-center justify-center bg-blue-100 p-2 rounded-full cursor-pointer hover:bg-blue-500 hover:text-white ml-2"
                              onClick={() => handleStatusClick(item._id)}
                            >
                              <MdModeEdit className="text-xl" />
                            </button>
                          </>
                          ) :
                          item.status === 'accepted'&& item.salesManName !== ''?
                           (
                            <>
                            <CiDeliveryTruck className="inline-block mr-2 text-blue-500 text-2xl" />
                            تم تحضير الطلب وجاري التوصيل
                          </>
                           )
                        : item.status === 'done'
                        ? (
                            <>
                              <MdOutlineDoneOutline className="inline-block mr-2 text-green-500 text-2xl" />
                              تم توصيل الطلب بنجاح
                            </>
                          )
                          
                        :
                        
                        item.status === 'refused'?
                        (
                          <>
                          
                          <HiXCircle className="inline-block mr-2 text-red-500 text-2xl" />
                          تم الرفض 
                         
                        </>
                        ) :item.status 
                    }
                    </td>
                    }
                      {item.source === 'order'&& item.type ==='refund'&&
                   <td className="text-center py-2 px-6 border border-gray-300">
                    {   
                         item.status === 'done'
                        ? (
                            <>
                              <RiRefund2Fill className="inline-block mr-2 text-green-500 text-2xl" />
                             تم اعادة الطلب بنجاح (مرتجع)
                            </>
                          )
                        : item.status 
                    }
                    </td>
                    }
                        {item.source === 'payment' && (
                        <td className="text-center py-2 px-6 border border-gray-300">
                            {item.state === 'accepted' ? (
                            <div className="flex items-center justify-center space-x-2">
                                <span>تم الدفع لمندوب المبيعات</span>
                                <button
                                className="bg-green-100 p-2 rounded-full cursor-pointer hover:bg-green-500 hover:text-white"
                                onClick={() => {
                                    setSelectedRequest(item);
                                    setOpenChangeStatus(true);
                                }}
                                >
                                <MdModeEdit size={20} />
                                </button>
                            </div>
                            ) : item.state === 'done' ? (
                            'تم الدفع للشركة'
                            ) : (
                            item.state // For other states, you can display the state value or a default message
                            )}
                        </td>
                        
                        )}



                    <td className="text-center py-2 px-6 border border-gray-300">
                      {item.source === 'order' ? displayINRCurrency(item.totalPrice) : displayINRCurrency(item.deptQuantity)}
                    </td>


                   
                    {type==='Medicine' &&
                    <td className='py-2 px-4 border border-gray-300 text-sm'>{displayINRCurrency(item.medicineDebt)}</td>
                    }

                    {type==='Cosmetic' &&
                    <td className='py-2 px-4 border border-gray-300 text-sm'>{displayINRCurrency(item.cosmeticDebt)}</td>
                    }
                  

                    <td className="text-center py-2 px-6 border border-gray-300">
                      {moment(item.createdAt).format('LLL')}
                    </td>
                    {item.source === 'order'  && (
                      <td className="text-center py-2 px-6 border border-gray-300">
                        <button onClick={() => handleViewOrder(item._id)} className="bg-blue-500 text-white px-4 py-2 rounded-lg">
                          <FaEye />
                        </button>
                      </td>
                    )}
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </main>
      {/* ChangeOrderStatus Component for Modal */}
      {selectedOrderId && !showChangeSalesMan && (
      <ChangeOrderStatus
        orderId={selectedOrderId}
        currentStatus={selectedStatus}
        onClose={() => closeModal(false)}
        callFunc={refreshData}
        type={type}
      />
    )}

    {/* ChangeSalesMan Component for Modal */}
    {showChangeSalesMan && (
      <ChangeSalesMan
        requestId={selectedOrderId}
        currentSalesman={currentSalesman}
        onClose={() => closeModal(false)}
        callFunc={refreshData}
        type={type}
      />
    )}

                        {/* Change Status Modal */}
                        {openChangeStatus && selectedRequest && (
                        <ChangeRequestStatus
                            requestId={selectedRequest._id}
                            currentStatus={selectedRequest.state}
                            onClose={() => setOpenChangeStatus(false)}
                            callFunc={refreshData}
                            type={type}
                        />
                    )}


    </div>
  );
};

export default AdminPaymentAndOrders;
